import { render } from "./ObsRespReportes.vue?vue&type=template&id=29163311&scoped=true"
import script from "./ObsRespReportes.vue?vue&type=script&lang=js"
export * from "./ObsRespReportes.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=29163311&scoped=true&lang=css"
import "./ObsRespReportes.vue?vue&type=style&index=1&id=29163311&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29163311"]])

export default __exports__